import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import { USER_STATUS } from "@typings/entities/users/enums";

export async function unblockUser(userId: string): Promise<void> {
  await apiClient.patch(apiPaths.users.update(userId), {
    status: USER_STATUS.Enabled,
  });
}
